import { render, staticRenderFns } from "./SelectableAnswerComponent.vue?vue&type=template&id=946087f2&scoped=true&"
import script from "./SelectableAnswerComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectableAnswerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946087f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
